module.exports = __webpack_public_path__ + "static/media/file-icon.b84e5382.svg";